import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import { APPLICATIONOTHERAPPOPTION, OTHERAPPOPTION, reasonOptions } from '../../appconfig/Settings';
import { applicationChangeStatusValidate } from '../../config/Validate';
import { postAllData } from '../../service/ProductService';
import { CHANGESTATUS } from '../../config/ApiConstant';

const ApprovalModal = (props: any) => {
    const navigate = useNavigate();
    const toast = useRef<any>(null);

    const [errors, setErrors] = useState<any>({});
    const [selectedApplicationStatus, setSelectedApplicationStatus] = useState<any>(null);
    const [reason, setReason] = useState<any>(null);
    const [documentList, setDocumentList] = useState<any>([]);
    const [unverifiedDocs, setUnverifiedDocs] = useState<any>([]);
    const [changeStatusLoader, setChangeStatusLoader] = useState<boolean>(false);

    // On close change status modal
    const onCloseChangeStatusModal = () => {
        setSelectedApplicationStatus(null);
        setReason(null);
        setDocumentList([]);
        setChangeStatusLoader(false);
        setErrors({});
        props.close();
    };

    // On select application status
    const onSelectApplicationStatus = (val: any) => {
        setSelectedApplicationStatus(val);
        if (val?.name === 'Document Not Proper') {
            let dList: any = props.docList.map((item: any) => {
                return {
                    documentName: item.DocName
                };
            });
            setDocumentList(dList);
        }
    };

    // On change unverified docs checkbox
    const onUnverifiedDocsChange = (e: any) => {
        let _unverifiedDocs = [...unverifiedDocs];

        if (e.checked) _unverifiedDocs.push(e.value);
        else _unverifiedDocs.splice(_unverifiedDocs.indexOf(e.value), 1);

        setUnverifiedDocs(_unverifiedDocs);
    };

    // On submit change status
    const onSubmitAddChangeStatus = async () => {
        try {
            const { errors, isError } = applicationChangeStatusValidate(selectedApplicationStatus, reason, unverifiedDocs);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setChangeStatusLoader(true);

                //Request object
                let formData: any = new FormData();

                formData.append('id', props.id);
                formData.append('AppName', props.applicationName);
                formData.append('status', selectedApplicationStatus?.code);
                formData.append('comment', !window.cn(reason) ? reason?.code : '');

                if (props.applicationName == 'Fresh Registration' || props.applicationName == 'Transfer In' || props.applicationName == 'Fresh Registration Other State' || props.applicationName == 'Transfer DD/DNH') {
                    formData.append('unverified_doc', unverifiedDocs.toString());
                }

                // Api Call
                const response = await postAllData(CHANGESTATUS, formData);

                if (response) {
                    onCloseChangeStatusModal();

                    if (props.applicationName === 'Fresh Registration') {
                        setTimeout(() => {
                            navigate('/app/application/fresh-registration-list/' );
                        }, 2000);
                    } else if (props.applicationName === 'Transfer In') {
                        setTimeout(() => {
                            navigate('/app/application/fresh-registration-transfer-list/');
                        }, 2000);
                    } else if (props.applicationName === 'Fresh Registration Other State') {
                        setTimeout(() => {
                            navigate('/app/application/fresh-registration-other-list/' );
                        }, 2000);
                    } else if (props.applicationName === 'Transfer DD/DNH') {
                        setTimeout(() => {
                            navigate('/app/application/fresh-registration-transfer-list-diu-daman/' + btoa(selectedApplicationStatus?.name));
                        }, 2000);
                    }  else {
                    }
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setChangeStatusLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            {/* Add Update Dialog */}
            <Dialog
                visible={props.visible}
                className="p-fluid"
                style={{ width: '120vh' }}
                header="Change Application Status"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={onCloseChangeStatusModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddChangeStatus()} loading={changeStatusLoader} />
                    </>
                }
                onHide={onCloseChangeStatusModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">Select Application Status</label>
                        <Dropdown
                            value={selectedApplicationStatus}
                            name="appStatus"
                            options={props.appName == 'Fresh Registration' || props.appName == 'Fresh Registration Other State' || props.appName == 'Transfer In' || props.appName == 'Transfer DD/DNH' ? APPLICATIONOTHERAPPOPTION : OTHERAPPOPTION}
                            filter
                            optionLabel="name"
                            placeholder="Select Status"
                            onChange={(e) => onSelectApplicationStatus(e.value)}
                            className={errors['appStatus'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['appStatus']}</small>
                    </div>
                    {!window.cn(selectedApplicationStatus) && selectedApplicationStatus?.name === 'Document Not Proper' ? (
                        <>
                            {documentList.map((item: any, index: any) => {
                                return (
                                    <>
                                        <div className="field col-12">
                                            <div className="flex align-items-center">
                                                <Checkbox inputId={item.documentName} name={item.documentName} value={item.documentName} checked={unverifiedDocs.includes(item.documentName)} onChange={onUnverifiedDocsChange} />
                                                <label htmlFor={item.documentName} className="ml-2">
                                                    {item.documentName}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                            <small className="p-invalid-txt">{errors['unverified_docs']}</small>
                        </>
                    ) : (
                        <div className="field col-12">
                            <label htmlFor="name">Reason</label>
                            <Dropdown value={reason} name="reason" options={reasonOptions} filter optionLabel="name" placeholder="Select Reason" onChange={(e) => setReason(e.value)} className={errors['reason'] && 'p-invalid'} />
                            <small className="p-invalid-txt">{errors['reason']}</small>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default ApprovalModal;
